export default {
  ChooseSalaryAccounting: 'Chọn chứng từ sinh hạch toán chi phí lương',
  ChooseInsuaranceAccounting: 'Chọn chứng từ sinh hạch toán chi phí bảo hiểm',
  ChooseTime: 'Chọn khoảng thời gian',
  GetData: 'Lấy dữ liệu',
  From: 'Từ',
  To: 'Đến',
  Cancel: 'Hủy',
  Execute: 'Thực hiện',
  ExecuteShortKey: 'Thực hiện (Ctrl + S)',
  PaymentVoucher: 'Chọn chứng từ chi trả lương',
};
